export default __webpack_public_path__ + "static/media/keyvis_text_tab.89abef83.png";